module.exports = __webpack_public_path__ + "img/banner-org.deef8e80.png";